import React from "react";

const NumberedList = (props) => {
  return (
    <div>
      <ul className="w-100">
        {props?.list &&
          Array.isArray(props?.list) &&
          props.list.map((elem, idx) => {
            return (
              <li
                key={idx}
                className={`d-flex flex-row justify-content-between align-items-start h5 fw-${
                  props?.fontWeight || "l"
                }`}
              >
                <span style={{ width: "6%" }}>{idx + 1}.</span>
                <span
                  style={{ width: "94%" }}
                  dangerouslySetInnerHTML={{
                    __html: elem[props?.searchKey || "title"],
                  }}
                />
                {/* {elem} */}
                {/* </span> */}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default React.memo(NumberedList);
